import { render } from "./Vitalsignsdescriptivestats.vue?vue&type=template&id=0cb9a546&scoped=true"
import script from "./Vitalsignsdescriptivestats.js?vue&type=script&lang=js"
export * from "./Vitalsignsdescriptivestats.js?vue&type=script&lang=js"

import "./Vitalsignsdescriptivestats.vue?vue&type=style&index=0&id=0cb9a546&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb9a546"]])

export default __exports__